import { isValid, parseISO, formatDistanceStrict } from 'date-fns';

const duration = (from, to) => {
  let dateFrom;
  let dateTo;

  try {
    dateFrom = typeof from === 'string' ? parseISO(from) : new Date(from);
    dateTo = typeof to === 'string' ? parseISO(to) : new Date(to);
  } catch {
    return 'Invalid date';
  }

  const isValidFrom = isValid(dateFrom);
  const isValidTo = isValid(dateTo);

  if (!isValidFrom || !isValidTo) {
    return 'Invalid date';
  }

  let humanizedString = formatDistanceStrict(dateFrom, dateTo, {
    addSuffix: true,
    includeSeconds: true,
  });

  humanizedString = humanizedString.replace(/\s+ago$/, '').trim();

  if (humanizedString === '0 seconds') {
    return 'a few seconds';
  }

  return humanizedString;
};

export default duration;
